import * as React from 'react'

export function Settings(props){
  return (
    <div>
      <h2>Settings</h2>
    </div>
  )
}